import { create } from "zustand";

const mergeDefinedValues = (currentValue, nextValue) => {
  if (!nextValue) {
    return currentValue;
  }

  const definedEntries = Object.entries(nextValue).filter(
    ([, value]) => value !== undefined
  );

  return {
    ...currentValue,
    ...Object.fromEntries(definedEntries),
  };
};

export const useSettlementStore = create((set) => ({
  caseDetail: null,
  feeSchedule: null,
  refreshVersion: 0,
  isFeeScheduleLoading: false,
  setCaseDetail: (caseDetail) => set({ caseDetail }),
  setFeeSchedule: (feeSchedule) => set({ feeSchedule }),
  setFeeScheduleLoading: (isFeeScheduleLoading) => set({ isFeeScheduleLoading }),
  bumpRefreshVersion: () =>
    set((state) => ({
      refreshVersion: state.refreshVersion + 1,
    })),
  mergeCaseDetail: (caseDetailPatch) =>
    set((state) => ({
      caseDetail: state.caseDetail
        ? mergeDefinedValues(state.caseDetail, caseDetailPatch)
        : caseDetailPatch,
    })),
  reset: () =>
    set({
      caseDetail: null,
      feeSchedule: null,
      refreshVersion: 0,
      isFeeScheduleLoading: false,
    }),
}));
